import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Tabs, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SupportLayout from "../support/SupportLayout";
import AdminBusinesses from "./components/AdminBusinesses";
import AdminSupportManagers from "./components/AdminSupportManagers";
import AdminRiders from "./components/AdminRiders";
import AdminZones from "./components/AdminZones";
import AdminAmbassadors from "./components/AdminAmbassadors";

const AdminApprovals = ({ useLayout = true }) => {
  const [activeTab, setActiveTab] = useState("businesses");

  const userProfile = useSelector((state) => state.userProfile?.user);
  const userRole = userProfile?.role?.toUpperCase() || "ADMIN";

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const content = (
    <div className="pb-40">
      <div className="main_container_title_div mb-5 mt-10">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
          Approvals & Ambassadors
        </h1>
        <p className="text-gray-600 text-xl sm:text-base">
          Manage business, support manager, biker approvals, and ambassador
          profiles
        </p>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        className="support-tabs"
      >
        <Tabs.TabPane tab="Zones" key="zones">
          <div className="mt-6">
            <AdminZones />
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Pending Businesses" key="businesses">
          <div className="mt-6">
            <AdminBusinesses defaultStatus="pending" />
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Pending Ambassadors" key="ambassadors">
          <div className="mt-6">
            <AdminAmbassadors showHeader={false} pendingOnly={true} />
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Support Staffs" key="support-managers">
          <div className="mt-6">
            <AdminSupportManagers />
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Konnect Delivery" key="konnect-delivery">
          <div className="mt-6">
            <AdminRiders />
          </div>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );

  if (useLayout) {
    return <SupportLayout userRole={userRole}>{content}</SupportLayout>;
  }

  return content;
};

export default AdminApprovals;
